import styled from 'styled-components'

import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'


export const _LinkWrapper = styled(AppLinkMobileCtrl)`
  text-decoration: none;
`
